<div class="sub-header-container pl-4 d-flex" [ngClass]="!isHomePage ? 'sub-header-border-bottom' : ''">
  <ng-container>
    @if (isHomePage) {
      <div class="d-none d-sm-flex">
        <div class="d-flex align-items-center cursor-pointer">
          <a routerLink="/home" routerLinkActive="sub-header-border-bottom" [routerLinkActiveOptions]="{ exact: true }" class="sub-header-default-border-bottom text-uppercase text-white font-weight-bold font-shadow-dark d-flex h-100 align-items-center">
            <ng-container  i18n="@@app.my_projects">My Projects</ng-container>
            <span class="badge border-rounded ml-2 mt-1 bg-white text-color-brand box-shadow-number text-shadow-none font-size-12">{{projectsCount}}</span>
            @if (myProjectsNotificationDot) {
              <span class="dot d-inline-block color-se-orange"></span>
            }
          </a>
        </div>
        <div class="mx-3"></div>
        <div class="d-flex align-items-center cursor-pointer">
          <a routerLink="/home/shared" routerLinkActive="sub-header-border-bottom" class="sub-header-default-border-bottom text-uppercase text-white font-weight-bold font-shadow-dark d-flex h-100 align-items-center">
            <ng-container i18n="@@app.shared_projects">Shared Projects</ng-container>
            <span class="badge border-rounded ml-2 mt-1 bg-white text-color-brand box-shadow-number text-shadow-none font-size-12">{{sharedProjectsCount}}</span>
            @if (sharedProjectsPendingCount > 0) {
              <span class="dot d-inline-block color-se-orange"></span>
            }
          </a>
        </div>
        <div class="mx-3"></div>
        <div class="d-flex align-items-center cursor-pointer">
          <a routerLink="/home/archived" routerLinkActive="sub-header-border-bottom" class="sub-header-default-border-bottom text-uppercase text-white font-weight-bold font-shadow-dark d-flex h-100 align-items-center">
            <ng-container i18n="@@app.archived_projects">Archived Projects</ng-container>
            <span class="badge border-rounded ml-2 mt-1 bg-white text-color-brand box-shadow-number text-shadow-none font-size-12">{{archivedProjectsCount}}</span>
          </a>
        </div>
        @if (userIsCompanyAdmin) {
          <div class="mx-3"></div>
          <div class="d-flex align-items-center cursor-pointer">
            <a routerLink="/home/company" routerLinkActive="sub-header-border-bottom" class="sub-header-default-border-bottom text-uppercase text-white font-weight-bold font-shadow-dark d-flex h-100 align-items-center">
              <ng-container i18n="@@app.company_projects">Company Projects</ng-container>
              <span class="badge border-rounded ml-2 mt-1 bg-white text-color-brand box-shadow-number text-shadow-none font-size-12">{{(companyProjectsAssigned || 0) + (companyProjectsUnassigned || 0)}}</span>
              @if (companyProjectsUnassigned > 0) {
                <span class="dot d-inline-block color-se-orange"></span>
              }
            </a>
          </div>
        }
      </div>
    }
    @if (isHomePage) {
      <div class="d-sm-none d-block p-2">
        <div class="menu-button display-flex align-items-center cursor-pointer text-white text-uppercase font-weight-bold p-0" (click)="toggleProjectsMenu(mobileSideMenu)">
          <i class="icon-24 font-size-24 font-weight-semibold line-height-24 se-icon icon-position pt-0 pb-0 pl-0 pr-2 cursor-pointer">burger_menu</i>
          <span i18n="@@app.menu">Menu</span>
        </div>
      </div>
    }
    <app-mobile-side-menu #mobileSideMenu>
      <app-mobile-side-menu-title><span i18n="@@app.menu">Menu</span></app-mobile-side-menu-title>
      <div class="px-3 py-2">
        <div class="mb-1">
          <a class="custom-item font-weight-bold font-size-12 d-block color-black"
            routerLink="/home"
            routerLinkActive="active-item"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeMobileMenu(mobileSideMenu)">
            My Projects
          </a>
        </div>
        <div class="mb-1">
          <a class="custom-item font-weight-bold font-size-12 d-block color-black"
            routerLink="/home/shared"
            routerLinkActive="active-item"
            (click)="closeMobileMenu(mobileSideMenu)">
            Shared Projects
          </a>
        </div>
        <div class="mb-1">
          <a class="custom-item font-weight-bold font-size-12 d-block color-black"
            routerLink="/home/archived"
            routerLinkActive="active-item"
            (click)="closeMobileMenu(mobileSideMenu)">
            Archived Projects
          </a>
        </div>
        @if (userIsCompanyAdmin) {
          <div class="mb-1">
            <a class="custom-item font-weight-bold font-size-12 d-block color-black"
              routerLink="/home/company"
              routerLinkActive="active-item"
              (click)="closeMobileMenu(mobileSideMenu)">
              Company Projects
            </a>
          </div>
        }
      </div>
    </app-mobile-side-menu>
    <div class="font-weight-bold d-flex align-items-center">
      @if (!isHomePage) {
        <a [routerLink]="[project?.isShared ? '/home/shared' : (project?.isArchived ? '/home/archived' : '/')]">
          <div class="pr-2 text-white width-max-content project-name-max-width">
            <img alt="" class="subheader-align" src="{{imagePath}}home_icon.svg" height="25">
          </div>
        </a>
      }
      @if (!isHomePage) {
        <div class="pr-2">
          <img alt="" src="{{imagePath}}bread_crumb_arrow_icon.svg" height="25">
        </div>
      }
      @if (project) {
        <a [routerLink]="['/project', project.projectId, 'overview']">
          <div class="pr-2 pb-1 text-white width-max-content font-shadow-dark">
            {{project.projectName}}
            @if (project?.isShared) {
              <img class="ml-1 shared-icon" alt="" src="/assets/images/shared.svg" [title]="project?.projectOwner?.firstName + ' ' + project?.projectOwner?.lastName" />
            }
          </div>
        </a>
      }
      <div>
        @if (currentEnclosure) {
          <img alt="" src="{{imagePath}}bread_crumb_arrow_icon.svg" height="25">
        }
      </div>
      <div class="dropdown">
        <button data-toggle="dropdown" (click)="toggleEnclosureList()"
          class="enclosure-subtitle bg-transparent border-0 font-weight-bold text-white no-outline d-flex align-items-center font-shadow-dark" [ngClass]="currentEnclosure?.productRangeId === 0 ? 'enclosure-title-without-type' : 'enclosure-title'">
          {{currentEnclosure?.name}}
          <span class="iconWidth d-inline-block pl-1 pt-1 min-height-26-px">
            @if (enclosures?.length > 0) {
              <img alt="" class="pt-1" [src]="openedEnclosureList ? '/assets/images/arrow_up_big_white_icon.svg' : '/assets/images/arrow_down_big_white_icon.svg' ">
            }
          </span>
        </button>
        <div class="float-left enclosure-subtitle text-white font-shadow-dark" [ngClass]="currentEnclosure?.productRangeId === 0 ? 'enclosure-title-without-type' : 'enclosure-title'">
          <app-enclosure-information [enclosure]="currentEnclosure"></app-enclosure-information>
        </div>
        @if (enclosures?.length > 0) {
          <div class="dropdown-menu fix-dropdown-position overflow-y-auto box-shadow">
            @for (enclosure of enclosures; track trackByFn($index, enclosure)) {
              <a appScrollIntoView [delayedScroll]="openedEnclosureList" class="cursor-pointer dropdown-item"
                [ngClass]="{ 'active':  enclosure.enclosureId === selectedId }"
                (click)="selectEnclosure(enclosure)">
                <div class="font-weight-bold">{{enclosure.name}}</div>
                <app-enclosure-information [enclosure]="enclosure"></app-enclosure-information>
              </a>
            }
          </div>
        }
      </div>
    </div>
    @if (!isHomePage) {
      <div class="position-relative d-flex align-items-center ml-auto mr-2 mr-3 mr-md-4 mr-lg-5">
        <app-ui-notifications-button
          [notifications]="notifications"
          (removeNotification)="removeFromNotifications($event)"
          (clearNotifications)="clearAllNotifications()"
        ></app-ui-notifications-button>
      </div>
    }
  </ng-container>
</div>
